var _defs, _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotnet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 101.156,
    height: 96.608,
    viewBox: "0 0 101.156 96.608",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    y1: -0.195,
    x2: 0.5,
    y2: 1.296,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0994dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#66cef5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#127bca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#127bca"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.5,
    y1: -0.195,
    x2: 0.5,
    y2: 1.296,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0e76bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#36aee8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#00adef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00adef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.5,
    y1: 1.109,
    x2: 0.5,
    y2: -0.062,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c63b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#33bdf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33bdf2",
    stopOpacity: 0.42
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.5,
    y1: -0.195,
    x2: 0.5,
    y2: 1.296,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#166ab8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#36aee8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#0798dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0798dd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.5,
    y1: -0.195,
    x2: 0.5,
    y2: 1.296,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#124379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#1487cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#165197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#165197"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33bdf2",
    stopOpacity: 0.698
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1dacd8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0.5,
    y1: 0.947,
    x2: 0.5,
    y2: -0.03,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#136ab4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#59caf5",
    stopOpacity: 0.549
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59caf5",
    stopOpacity: 0.235
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#05a1e6",
    stopOpacity: 0.247
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05a1e6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 0.5,
    y1: 1.243,
    x2: 0.5,
    y2: -0.094,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#318ed5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38a7e4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 0.5,
    y1: 0.912,
    x2: 0.5,
    y2: -0.768,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#05a1e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05a1e6",
    stopOpacity: 0.549
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1959a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#05a1e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#7ec5ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ec5ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 0.598,
    y1: 0.946,
    x2: 0.385,
    y2: 0.058,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#165096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d82ca"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 0.5,
    y1: 0.77,
    x2: 0.5,
    y2: -0.033,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#05a1e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#0495d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0495d6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 0.653,
    y1: -0.042,
    x2: 0.343,
    y2: 1.058,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#38a7e4",
    stopOpacity: 0.329
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.962,
    stopColor: "#0e88d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e88d3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 0.5,
    y1: -0.003,
    x2: 0.5,
    y2: 1.019,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#168cd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1c87cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#154b8d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 0.167,
    y1: -1.056,
    x2: 0.878,
    y2: 1.198,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#97d6ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#55c1ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55c1ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 0.069,
    y1: 0.937,
    x2: 0.758,
    y2: -0.168,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7accec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3fb7ed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 0.5,
    y1: 0.064,
    x2: 0.5,
    y2: 1.28,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1da7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37abe7",
    stopOpacity: 0
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.6,121.58a.453.453,0,0,0-.143-.372.893.893,0,0,0-.548-.132h-.369v1.014h.445c.411,0,.615-.171.615-.51Zm.575,2.115h-.507l-.324-.714c-.164-.358-.34-.537-.531-.537h-.273v1.25h-.418V120.72h.838a1.241,1.241,0,0,1,.843.249.712.712,0,0,1,.244.56.733.733,0,0,1-.2.521,1.006,1.006,0,0,1-.556.293v.013c.166.039.332.221.493.549l.392.792v0Zm.926-1.458a1.986,1.986,0,0,0-.6-1.472,2.079,2.079,0,1,0-1.463,3.546,2.046,2.046,0,0,0,2.061-2.074Zm.281-.013a2.217,2.217,0,0,1-.679,1.652,2.446,2.446,0,0,1-3.342.019,2.377,2.377,0,0,1,.011-3.3,2.432,2.432,0,0,1,3.326-.031,2.2,2.2,0,0,1,.685,1.663ZM39.8,130.52H38.359v-8.252c0-.652.043-1.445.119-2.381h-.032a7.831,7.831,0,0,1-.368,1.19l-4.191,9.444h-.7l-4.2-9.375a6.876,6.876,0,0,1-.367-1.258h-.031c.044.493.069,1.291.069,2.4v8.236h-1.39V118.231h1.9l3.77,8.569a11.091,11.091,0,0,1,.558,1.472h.06c.246-.672.44-1.175.588-1.507L38,118.231h1.8v12.288h0Zm4.435,0h-1.4v-8.775h1.4Zm.242-11.921a.879.879,0,0,1-.271.652.891.891,0,0,1-.653.266.907.907,0,0,1-.647-.256.935.935,0,0,1,0-1.307.942.942,0,0,1,1.3,0A.867.867,0,0,1,44.479,118.6Zm8.515,11.515a4.511,4.511,0,0,1-2.4.618,3.956,3.956,0,0,1-3.045-1.252,4.428,4.428,0,0,1-1.13-3.136,4.893,4.893,0,0,1,1.24-3.485,4.325,4.325,0,0,1,3.328-1.328,4.48,4.48,0,0,1,2.03.445v1.442a3.563,3.563,0,0,0-2.091-.688,2.811,2.811,0,0,0-2.185.935,3.624,3.624,0,0,0-.884,2.552,3.479,3.479,0,0,0,.811,2.426,2.791,2.791,0,0,0,2.17.891,3.542,3.542,0,0,0,2.158-.754v1.334Zm6.7-6.945a1.878,1.878,0,0,0-2.512.487,3.849,3.849,0,0,0-.66,2.39v4.474h-1.4v-8.775h1.4v1.809h.034a3.083,3.083,0,0,1,.951-1.483,2.1,2.1,0,0,1,1.344-.48,2.284,2.284,0,0,1,.842.12v1.458Zm7.828,2.98a3.835,3.835,0,0,0-.761-2.57,2.593,2.593,0,0,0-2.066-.849,2.707,2.707,0,0,0-2.1.859,3.725,3.725,0,0,0-.831,2.595,3.547,3.547,0,0,0,.8,2.463,2.718,2.718,0,0,0,2.133.888,2.565,2.565,0,0,0,2.115-.9,3.848,3.848,0,0,0,.712-2.486m1.44-.05a4.731,4.731,0,0,1-1.182,3.364,4.155,4.155,0,0,1-3.19,1.268,4.031,4.031,0,0,1-3.134-1.268,4.569,4.569,0,0,1-1.132-3.229,4.708,4.708,0,0,1,1.286-3.539,4.363,4.363,0,0,1,3.185-1.165,3.943,3.943,0,0,1,3.068,1.216,4.84,4.84,0,0,1,1.1,3.353m6.966,2.074a2.281,2.281,0,0,1-.807,1.788,3.536,3.536,0,0,1-2.407.771,4.3,4.3,0,0,1-2.177-.529v-1.51a3.53,3.53,0,0,0,2.281.841q1.668,0,1.67-1.226a1.083,1.083,0,0,0-.369-.847,5.829,5.829,0,0,0-1.44-.807,4.61,4.61,0,0,1-1.567-.995,2.421,2.421,0,0,1,.309-3.4,3.346,3.346,0,0,1,2.228-.727,4.166,4.166,0,0,1,1.876.411v1.414a3.31,3.31,0,0,0-1.991-.626,1.723,1.723,0,0,0-1.117.342,1.093,1.093,0,0,0-.423.884,1.173,1.173,0,0,0,.353.907,4.872,4.872,0,0,0,1.317.728,5.075,5.075,0,0,1,1.621.972,2.164,2.164,0,0,1,.644,1.609m8.584-2.024a3.827,3.827,0,0,0-.762-2.57,2.59,2.59,0,0,0-2.065-.849,2.718,2.718,0,0,0-2.1.859,3.731,3.731,0,0,0-.828,2.595,3.569,3.569,0,0,0,.79,2.463,2.74,2.74,0,0,0,2.138.888,2.563,2.563,0,0,0,2.115-.9,3.85,3.85,0,0,0,.712-2.486m1.443-.05a4.729,4.729,0,0,1-1.187,3.364,4.144,4.144,0,0,1-3.186,1.268,4.032,4.032,0,0,1-3.136-1.268,4.57,4.57,0,0,1-1.131-3.229,4.725,4.725,0,0,1,1.284-3.539,4.368,4.368,0,0,1,3.188-1.165,3.935,3.935,0,0,1,3.065,1.216,4.834,4.834,0,0,1,1.1,3.353m6.189-7.336a1.882,1.882,0,0,0-.933-.231c-.983,0-1.471.619-1.471,1.86v1.352H91.8v1.19H89.743v7.585H88.337v-7.586H86.845v-1.19h1.492v-1.422a2.91,2.91,0,0,1,.9-2.27,2.691,2.691,0,0,1,1.9-.71,2.74,2.74,0,0,1,1.018.153v1.268Zm5.544,11.668a2.648,2.648,0,0,1-1.32.285q-2.3,0-2.3-2.59v-5.191H92.569v-1.192h1.505V119.6c.448-.142.915-.3,1.408-.455v2.6h2.209v1.192H95.482v4.952a2.007,2.007,0,0,0,.3,1.253,1.212,1.212,0,0,0,1,.376,1.488,1.488,0,0,0,.909-.283Z",
    transform: "translate(-16.75 -70.697)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 63.871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.82,190.88a2.453,2.453,0,0,1-.741,1.785,2.436,2.436,0,0,1-1.8.753,2.337,2.337,0,0,1-1.752-.753,2.592,2.592,0,0,1,0-3.583,2.343,2.343,0,0,1,1.752-.741,2.428,2.428,0,0,1,1.8.751,2.457,2.457,0,0,1,.741,1.788M37.269,192.9H32.689L16.06,167.221a11.784,11.784,0,0,1-1.008-2.023h-.137a33.443,33.443,0,0,1,.179,4.425V192.9H11.318V160.682h4.9L32.35,185.958c.642,1,1.081,1.721,1.3,2.154h.09a33.886,33.886,0,0,1-.228-4.737V160.682H37.27V192.9Zm24.21,0H44.4V160.682H60.738V164.1H48.177v10.718h11.64v3.416H48.177v11.256h13.3V192.9Zm25.9-28.8H78.1v28.8H74.325V164.1h-9.3v-3.416H87.381V164.1Z",
    transform: "translate(-0.81 -160.681)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.07 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.5,18.693c3.643,11.14,5.023,31.014,15.676,31.014a13.105,13.105,0,0,0,2.453-.236C96.944,47.213,95.8,27.556,89.887,17.376q-.707.645-1.388,1.317",
    transform: "translate(-53.391 -10.469)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.992,15.77c5.909,10.18,7.057,29.837,16.741,32.095a15.36,15.36,0,0,0,2.287-.618C102.328,42.988,99.925,23.9,93.214,14.71q-.621.518-1.222,1.06",
    transform: "translate(-55.495 -8.863)",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.568,2.145a13.148,13.148,0,0,0-2.455.236A18.792,18.792,0,0,0,91.561,5.12a16.259,16.259,0,0,1,1.716,2.019,23.535,23.535,0,0,1,6.7-4.067,14.933,14.933,0,0,1,2.5-.694,7.7,7.7,0,0,0-1.905-.233",
    transform: "translate(-55.557 -1.292)",
    fill: "#14559a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.6,35.776q1.389-1.11,2.673-2.342c-3.7-11.089-5.026-31.247-15.754-31.247A12.7,12.7,0,0,0,118.2,2.4c9.772,2.43,11.024,23.69,15.4,33.374",
    transform: "translate(-71.287 -1.318)",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.125,2.376a7.7,7.7,0,0,0-1.905-.232l4.219.016a12.56,12.56,0,0,0-2.313.216",
    transform: "translate(-69.209 -1.292)",
    fill: "#3092c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.269,90.632a15.894,15.894,0,0,1-1.21-1.307A22.188,22.188,0,0,1,140.67,92.2a8.3,8.3,0,0,0,2.009.685,8.514,8.514,0,0,0,1.712.169,11.225,11.225,0,0,0,4.939-.884,9.376,9.376,0,0,1-2.061-1.54",
    transform: "translate(-85.145 -53.818)",
    fill: "#1969bc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.917,3.424c8.752,4.578,9.513,25.308,16.5,33.726q.713-.5,1.4-1.049c-4.372-9.684-5.622-30.946-15.392-33.374a15.129,15.129,0,0,0-2.5.7",
    transform: "translate(-67.5 -1.643)",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.067,8.547c6.711,9.189,9.114,28.278,17.806,32.537a22.181,22.181,0,0,0,5.389-2.877c-6.984-8.418-7.745-29.148-16.5-33.726a23.5,23.5,0,0,0-6.7,4.066",
    transform: "translate(-57.348 -2.7)",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.506,15.912A100.069,100.069,0,0,0,69.081,25.5,71.251,71.251,0,0,1,76.8,16.18,27.929,27.929,0,0,0,75.66,13.2a38.464,38.464,0,0,0-3.154,2.707",
    transform: "translate(-41.691 -7.956)",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.377,11.479q-.471.335-.932.686a27.985,27.985,0,0,1,1.138,2.975q.682-.671,1.388-1.317a18.452,18.452,0,0,0-1.594-2.344",
    transform: "translate(-52.475 -6.916)",
    fill: "#2b74b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.89,9.629q-.559.355-1.1.735a18.528,18.528,0,0,1,1.6,2.346q.6-.544,1.222-1.061A16.221,16.221,0,0,0,89.89,9.629",
    transform: "translate(-53.887 -5.801)",
    fill: "#125a9e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.411,0c-4.95,19.09-15.289,34.423-23.958,38.289h-.016c-.158.072-.314.137-.468.2a.378.378,0,0,1-.057.022l-.133.051a.348.348,0,0,1-.06.025c-.073.026-.145.048-.216.077-.031.013-.06.021-.089.031a1.1,1.1,0,0,1-.107.035c-.033.013-.067.022-.1.037s-.064.018-.093.031c-.064.018-.122.034-.185.056a.332.332,0,0,0-.078.021c-.039.013-.083.022-.126.034a.384.384,0,0,1-.084.023c-.044.013-.093.025-.137.035l-.166.037a3.53,3.53,0,0,0,1.24.218c8.22,0,16.507-14.73,30.219-39.225h-5.384l0,0Z",
    transform: "translate(-105.708 0)",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.782,2.908c.005,0,.012-.013.015-.013s.017,0,.02-.013h.01c.045-.016.087-.034.133-.051a.024.024,0,0,0,.026-.013c.012,0,.023-.013.034-.015.048-.016.1-.034.143-.05h.008c.109-.033.21-.073.315-.111.015,0,.029-.013.047-.013.044-.014.089-.03.135-.04a.252.252,0,0,1,.062-.02c.047-.014.093-.03.136-.04.02,0,.037-.013.052-.014.151-.042.3-.081.452-.117.021,0,.039-.013.062-.014a.871.871,0,0,1,.132-.026.232.232,0,0,1,.065-.019c.044-.013.086-.014.134-.025h.031c.091-.019.184-.034.275-.051h.055a1.16,1.16,0,0,1,.127-.022c.024,0,.048-.013.072-.013a.988.988,0,0,0,.122-.018A.128.128,0,0,0,28.51,2.2c.1-.013.195-.018.3-.026q-.436-.044-.875-.046C18.675,2.125,5.922,19.3.177,41.542H1.284c1.838-3.279,3.49-6.38,5-9.292C10.308,16.5,18.5,5.752,25.782,2.905",
    transform: "translate(-0.177 -1.28)",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.509,13.711A38.448,38.448,0,0,1,81.662,11a14.887,14.887,0,0,0-.751-1.452,17.793,17.793,0,0,0-2.4,4.159",
    transform: "translate(-47.694 -5.755)",
    fill: "#0d82ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.244,4.331a7.9,7.9,0,0,1,1.642,2.04c.156-.192.314-.369.478-.535a9.282,9.282,0,0,0-2.237-1.565,1.07,1.07,0,0,0,.1.047s.013.013.018.013",
    transform: "translate(-48.669 -2.573)",
    fill: "#0d82ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.54,33.437c8.441-16.265,12.439-26.558,19.5-29.345C27.76,6.941,19.564,17.684,15.54,33.437",
    transform: "translate(-9.433 -2.465)",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.029,8.208c-.164.167-.32.343-.478.535a15.1,15.1,0,0,1,.752,1.451q.46-.35.932-.686a12.675,12.675,0,0,0-1.206-1.3",
    transform: "translate(-51.334 -4.945)",
    fill: "#127bca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.155,66.767a1.052,1.052,0,0,1-.153.018h-.029c-.044,0-.09.013-.13.013h-.021c-.106.013-.21.013-.31.021h-.033C32.021,66.58,35.925,62.3,37.864,56.1c1.473-4.7,2.682-8.665,3.742-11.989A169.812,169.812,0,0,0,30.82,61.875a8.849,8.849,0,0,1-6.665,4.885",
    transform: "translate(-14.216 -26.576)",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.179,52.24a8.842,8.842,0,0,0,6.665-4.885A170.7,170.7,0,0,1,42.629,29.59,99.806,99.806,0,0,1,46.056,20c-7.125,6.782-14.278,18.059-20.877,32.232",
    transform: "translate(-15.241 -12.053)",
    fill: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.771,77.916c-1.511,2.911-3.162,6.013-5,9.292H6.99a78.711,78.711,0,0,1,1.78-9.29",
    transform: "translate(-2.664 -46.944)",
    fill: "#05a1e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.081,2.311c-.026,0-.046.013-.068.013a.53.53,0,0,1-.12.017.14.14,0,0,0-.072.013c-.044.013-.084.014-.127.022a.084.084,0,0,0-.055.013l-.274.048h-.031a1.04,1.04,0,0,1-.134.026.229.229,0,0,1-.067.018,1.214,1.214,0,0,1-.13.026.124.124,0,0,1-.062.014c-.151.037-.3.076-.452.117-.016,0-.033.013-.052.016l-.137.04a.182.182,0,0,1-.062.018l-.135.04c-.017,0-.032.013-.048.013-.1.039-.207.078-.314.111-.045.014-.094.033-.143.05a.285.285,0,0,1-.06.025c-.046.014-.091.033-.134.049a.213.213,0,0,1-.044.021C25.3,5.807,21.3,16.1,12.863,32.365a78.366,78.366,0,0,0-1.78,9.291h.452c1.273,0,1.632-.013,3.1-.013h1.419c.1-.013.2-.013.31-.021h.02c.044,0,.087-.013.13-.013h.031c.047,0,.1-.013.153-.018,6.6-14.173,13.751-25.45,20.877-32.232a17.835,17.835,0,0,1,2.4-4.157,7.877,7.877,0,0,0-1.64-2.042s-.016,0-.017-.013c-.035-.014-.067-.031-.1-.048s-.064-.033-.1-.051a1.076,1.076,0,0,1-.1-.047.987.987,0,0,1-.114-.048l-.089-.039q-.094-.037-.187-.078c-.028-.013-.054-.02-.079-.03q-.071-.026-.14-.056a.423.423,0,0,0-.075-.025l-.193-.066h-.016c-.075-.025-.148-.043-.224-.064a.1.1,0,0,0-.05-.016l-.188-.053c-.016,0-.031-.013-.044-.013q-.233-.06-.47-.1c-.016,0-.032-.013-.048-.013q-.1-.02-.2-.033a.054.054,0,0,0-.041-.013q-.12-.018-.241-.031H35.57c-.065-.013-.125-.014-.185-.021-.1.013-.2.018-.3.027",
    transform: "translate(-6.748 -1.386)",
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.1,11.861c-1.624,5.2-2.939,9.494-4.084,13.025A141.433,141.433,0,0,0,195.046,2.138c-4.875,1.531-7.477,5.036-8.941,9.723",
    transform: "translate(-109.737 -1.288)",
    fill: "url(#m)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.347,37.975c-.227.116-.455.226-.68.325,8.668-3.866,19.007-19.2,23.958-38.289h-1c-11.373,20.316-15.03,33.916-22.275,37.964",
    transform: "translate(-108.921 -0.007)",
    fill: "url(#n)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.243,72.028c1.886-2.3,3.422-6.215,5.519-12.664a63.391,63.391,0,0,1-7.291,8.509c0,.013,0,.013-.013.021a22.193,22.193,0,0,0,1.78,4.134",
    transform: "translate(-99.478 -35.767)",
    fill: "#079ae1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.035,91.223a7.728,7.728,0,0,1-2.078,1.822c-.166.1-.333.187-.5.27a7.3,7.3,0,0,0,2.645.834c.143.014.285.027.432.038h.026a1.17,1.17,0,0,1,.208.013h.706a.174.174,0,0,0,.079-.013.632.632,0,0,0,.156-.013h.077c.053,0,.112-.013.169-.018h.013c.017,0,.035-.013.052-.013.06-.013.122-.018.18-.027h.054c.066-.013.135-.021.2-.034h.033c.136-.026.269-.052.4-.086a5.885,5.885,0,0,1-2.861-2.751",
    transform: "translate(-98.27 -54.961)",
    fill: "#1969bc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.746,97.417a13.013,13.013,0,0,0,2.453-.237,15.211,15.211,0,0,0,2.287-.616,8.315,8.315,0,0,0,2.007.684,8.53,8.53,0,0,0,1.714.169Z",
    transform: "translate(-77.961 -58.179)",
    fill: "#1e5cb3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.025,97.37a11.215,11.215,0,0,0,4.937-.884,7.306,7.306,0,0,0,2.645.834c.143.014.285.027.432.037h.026a1.133,1.133,0,0,1,.208.013h-8.249Z",
    transform: "translate(-90.778 -58.132)",
    fill: "#1e5cb3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.408,98.385h.464a.172.172,0,0,0,.08-.013.656.656,0,0,0,.158-.013h.077c.053,0,.112-.013.167-.018h.014c.017,0,.034-.013.051-.013.06-.013.122-.018.18-.028a.092.092,0,0,0,.056-.013c.066-.013.135-.019.2-.032h.033c.136-.026.27-.052.4-.086a3.531,3.531,0,0,0,1.24.218l-3.124.013Z",
    transform: "translate(-103.665 -59.147)",
    fill: "#1d60b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.3,80.8V80.79q-1.282,1.232-2.672,2.342-.683.544-1.4,1.049a15.821,15.821,0,0,0,1.21,1.307,9.379,9.379,0,0,0,2.061,1.539c.169-.083.338-.174.5-.27a7.707,7.707,0,0,0,2.079-1.822,22.244,22.244,0,0,1-1.78-4.134",
    transform: "translate(-93.318 -48.676)",
    fill: "#175fab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.887.011h-5.049c-.273.013-.538.022-.8.039-.124.265-.25.53-.372.8a141.4,141.4,0,0,1-13.025,22.748c-2.1,6.449-3.633,10.362-5.519,12.664a5.9,5.9,0,0,0,2.859,2.752.5.5,0,0,1,.088-.02h.018c.019,0,.041-.013.062-.013.045-.013.094-.021.14-.035a.693.693,0,0,1,.083-.024c.043-.013.086-.022.125-.032a.291.291,0,0,1,.078-.022c.065-.021.124-.037.186-.056a.529.529,0,0,1,.093-.031,1.1,1.1,0,0,0,.1-.037c.037-.013.075-.02.107-.034s.06-.021.087-.033c.073-.026.145-.048.218-.077.02,0,.039-.018.06-.022.044-.018.089-.033.133-.052a.159.159,0,0,1,.057-.021c.153-.064.31-.129.468-.2h.016q.344-.153.678-.325c7.245-4.048,10.9-17.648,22.276-37.964h-3.176l0,0Z",
    transform: "translate(-101.364 -0.007)",
    fill: "url(#o)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.009,2.241a.078.078,0,0,1,.052.013.414.414,0,0,1,.132.014h.044c.08.013.159.02.241.031a.05.05,0,0,1,.041.013c.067.013.135.024.2.034.015,0,.034.013.05.013.156.031.316.064.468.1.014,0,.029.013.042.013.065.016.124.035.189.053.02,0,.034.013.052.016.077.019.148.039.223.064,0,0,.008,0,.017.013.064.019.128.044.195.066a.393.393,0,0,0,.075.025c.046.02.1.039.14.057a.284.284,0,0,1,.079.028c.06.027.123.052.185.078.033.013.06.028.091.039a.774.774,0,0,0,.112.048l.1.047c.034.019.066.033.1.051a9.325,9.325,0,0,1,2.237,1.566,7.264,7.264,0,0,1,.793-.72A8.73,8.73,0,0,0,73.7,2.23c-.228,0-.455.013-.686.03",
    transform: "translate(-44.38 -1.344)",
    fill: "#7dcbec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.753,7.116a12.675,12.675,0,0,1,1.206,1.3q.542-.381,1.1-.735A11.629,11.629,0,0,0,86.545,6.4a7.1,7.1,0,0,0-.792.72",
    transform: "translate(-52.058 -3.853)",
    fill: "#5ec5ed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.872-6.351c.231-.019.458-.028.686-.028a8.74,8.74,0,0,1,5.173,1.673C78.318-5.958,80.236-6.4,82.9-6.4H70c.3,0,.589.018.875.044",
    transform: "translate(-42.243 7.248)",
    fill: "url(#p)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.106-9.63c-2.664,0-4.582.437-6.169,1.689a11.72,11.72,0,0,1,1.515,1.286A18.8,18.8,0,0,1,95.007-9.4,13.3,13.3,0,0,1,97.46-9.63H93.106Z",
    transform: "translate(-52.45 10.483)",
    fill: "url(#q)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.972,23.681c1.146-3.534,2.458-7.824,4.085-13.028C176.524,5.965,179.12,2.46,184,.931c.129-.262.25-.532.376-.8-7.948.476-11.662,4.519-13.532,10.506-3.269,10.453-5.249,17.229-7.156,21.546a63.527,63.527,0,0,0,7.289-8.505",
    transform: "translate(-98.689 -0.081)",
    fill: "url(#r)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.872,91.2h-.9V94H207.6V91.2h-.9v-.333h2.172V91.2ZM212.56,94h-.366V91.9c0-.166.013-.369.03-.608a2.158,2.158,0,0,1-.1.306L211.06,94h-.179l-1.069-2.388a1.688,1.688,0,0,1-.1-.324H209.7c.013.126.017.33.017.613V94h-.351V90.867h.485l.961,2.186a2.825,2.825,0,0,1,.142.376h.014c.064-.173.116-.3.151-.386l.981-2.176h.462V94Z",
    transform: "translate(-124.928 -54.747)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotnet);
export default __webpack_public_path__ + "static/media/dotnet.667ab80c93391eab6e879e37a1b24133.svg";
export { ForwardRef as ReactComponent };